// @flow
import {AUTH_MODULE_NAME} from 'modules/auth/constants';
import type {TAuthUser} from 'modules/auth/types/user';
import {USER_ROLE_DATA} from 'modules/user/constants';
import {createSelector} from 'reselect';
import type {TRootState} from 'types';

/**
 * Селектор модуля
 * @param state Глобальный стейт приложения
 * @returns state модуля
 */
export function selectModule(state: TRootState) {
    return state[AUTH_MODULE_NAME];
}

/**
 * Получить данные авторизированного юзера
 * @param state глобальный стор
 * @return данные авторизированного юзера
 */
export function selectUserData(state: TRootState): TAuthUser {
    return selectModule(state).user;
}

export const selectUserEducation: any = createSelector(
    (state) => selectUserData(state).education,
    (item) => item
);

/**
 * Селектор флага авторизации
 * @param state Глобальный стейт приложения
 * @returns state модуля
 */
export function selectIsStudent(state: TRootState): boolean {
    const user = selectUserData(state);
    if (user) {
        return user.role === USER_ROLE_DATA.STUDENT;
    }
    return true;
}
